import { render, staticRenderFns } from "./PaginationPageSizeFilter.vue?vue&type=template&id=2741a432&"
import script from "./PaginationPageSizeFilter.vue?vue&type=script&lang=js&"
export * from "./PaginationPageSizeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2741a432')) {
      api.createRecord('2741a432', component.options)
    } else {
      api.reload('2741a432', component.options)
    }
    module.hot.accept("./PaginationPageSizeFilter.vue?vue&type=template&id=2741a432&", function () {
      api.rerender('2741a432', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/PaginationPageSizeFilter.vue"
export default component.exports